import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import React from 'react';

import UploadManifest from 'components/atoms/UploadManifest/UploadManifest';
import UploadStepInfoCard from './UploadStepInfoCard';

const StudyCohortManifestStep = () => (
  <UploadStepInfoCard
    icon={<AssignmentOutlinedIcon color="secondary" fontSize="small" />}
    tone="manifest"
    title="Prepare case and slide metadata"
    description="Use the template below to define the cases, slides, and study metadata for this transfer."
  >
    <UploadManifest withTitle={false} />
  </UploadStepInfoCard>
);

export default StudyCohortManifestStep;
